
import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCartProductsWebuser } from "../../../redux/reduxApi/website/CartProductCount";
import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi";
import { getMotorsList } from "../../../redux/reduxApi/admin/MotorizationReduxApi";
import { getCustomerAddress } from "../../../redux/reduxApi/website/CustomerAddressApi";
import Shoploader from "../loader/Shoploader";
import Button from "../../../ui/Button";
import { motion } from "framer-motion";
import { LiaOpencart } from "react-icons/lia";
import { toast } from "react-toastify";
import { MapPin, Phone, Building, Home, Mail } from "lucide-react";
import { getShippingCharges } from "../../../redux/api/admin/SalesordersApi";
import { FaArrowLeft } from "react-icons/fa";

const OrderSummary = ({ createOrder, selectedAddressId, selectedAddress, shippingCost = 0, setShippingCost }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const [shippingCost, setShippingCost] = useState(0);
  const [shippingLoading, setShippingLoading] = useState(false);

  const userId = localStorage.getItem("UserRowId");
  const [address, setAddress] = useState(selectedAddress || {});
  const [showWarning, setShowWarning] = useState(false);

  // Get order data from location state (passed from checkout)
  const orderData = location.state?.orderData || {};
  const { orderId, orderDate, orderStatus } = orderData;

  const cart = useSelector((state) => {
    if (state.CartProducts?.data && Array.isArray(state.CartProducts.data)) {
      return state.CartProducts.data;
    }
    if (
      state.Cart?.CartProducts?.data &&
      Array.isArray(state.Cart.CartProducts.data)
    ) {
      return state.Cart.CartProducts.data;
    }
    return [];
  });
  console.log("Cart products in OrderSummary:", cart);
  console.log("Cart products in OrderSummary:sss", cart);

  const cartLoading = useSelector(
    (state) => state.CartProducts?.loading || false
  );

  useEffect(() => {
    const fetchUserCart = async () => {
      try {
        if (userId) {
          await dispatch(getCartProductsWebuser());
        }
      } catch (error) {
        console.error("Error fetching cart:", error);
        toast.error("Failed to load order details");
      }
    };

    fetchUserCart();
  }, [dispatch, userId]);

  // Fetch address details if selectedAddressId is provided but selectedAddress is not
  useEffect(() => {
    const fetchAddressDetails = async () => {
      if (selectedAddressId && !selectedAddress) {
        try {
          const response = await dispatch(getCustomerAddress(selectedAddressId)).unwrap();
          if (response?.data) {
            setAddress(response.data);
          }
        } catch (error) {
          console.error("Error fetching address:", error);
          toast.error("Failed to load address details");
        }
      } else if (selectedAddress) {
        setAddress(selectedAddress);
      }
    };

    fetchAddressDetails();
  }, [dispatch, selectedAddressId, selectedAddress]);

  const [shadesData, setShadesData] = useState([]);
  const [motorData, setMotorData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [quantities, setQuantities] = useState({});

  // Get inventory for product names
  const getInventory = useSelector((state) => state?.inventory?.inventory);

  // Get Shades data
  useEffect(() => {
    dispatch(getShadeNumberList())
      .then((response) => {
        const data = response.payload?.data?.shades || [];
        setShadesData(data);
      })
      .catch((error) => {
        console.error("Error fetching Shades data:", error);
      });
  }, [dispatch]);

  // Get Products data
  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        await dispatch(getProduct({ page: 1, limit: 300 }));
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchAllProducts();
  }, [dispatch]);

  // Get Motors data
  useEffect(() => {
    dispatch(getMotorsList())
      .then((res) => {
        const list = res?.payload?.data?.motors || [];
        setMotorData(list);
      })
      .catch((err) => {
        console.error("Error fetching motors:", err);
      });
  }, [dispatch]);

  // Initialize quantities from cart
  useEffect(() => {
    const initialQuantities = {};
    cart?.forEach((product) => {
      initialQuantities[product.ROWID] = Number(product?.quantity) || 1;
    });
    setQuantities(initialQuantities);
  }, [cart]);

  const buildShippingPayload = () => {
    return {
      location: address?.state || "",
      cartItems: cart.map((product) => ({
        productId: product.productId,
        width: Number(product.width) || 0,
        measurements: product.measurements || "mm",
        qty: quantities[product.ROWID] || product.quantity || 1,
        // optional
        motorType: product.motorization === "Yes" ? "yes" : null
      }))
    };
  };

  useEffect(() => {
    const fetchShipping = async () => {
      if (!address?.state || cart.length === 0) return;

      try {
        setShippingLoading(true);

        const payload = buildShippingPayload();

        // console.log("Shipping Payload:", payload);

        const res = await getShippingCharges(payload);

        // console.log("Shipping Response:", res);

        const price = res?.data?.totalPrice || 0;

        setShippingCost(price);


      } catch (err) {
        console.error("Shipping error:", err);
        toast.error("Failed to calculate shipping");
      } finally {
        setShippingLoading(false);
      }
    };

    fetchShipping();
  }, [address, cart, quantities]);

  // Helper functions
  const getShadeImageByShadeNo = (shadeNo) => {
    if (!shadesData || shadesData.length === 0 || !shadeNo) {
      return "/fallback-image.jpg";
    }
    const shade = shadesData.find((item) => item.shadeNo === shadeNo);
    if (shade && shade.shadeMedia && shade.shadeMedia.length > 0) {
      return shade.shadeMedia[0];
    }
    return "/fallback-image.jpg";
  };

  const getItemNameByProductId = (productId) => {
    if (!Array.isArray(getInventory)) return "N/A";
    const matched = getInventory.find((inv) => inv.ROWID === productId);
    return matched?.itemName || "N/A";
  };

  const getMotorNameById = (motorRowId) => {
    if (
      !motorRowId ||
      motorRowId === "N/A" ||
      !motorData ||
      motorData.length === 0
    ) {
      return "N/A";
    }
    const motor = motorData.find((m) => m.ROWID === motorRowId);
    return motor?.motorName || motorRowId || "N/A";
  };

  // Area calculation functions
  const inchesToSqFt = (widthInch, dropInch) => {
    return (widthInch * dropInch) / 144;
  };

  const mmToSqFt = (widthMm, dropMm) => {
    if (dropMm === 0) return 0;
    const effectiveDrop = dropMm < 1000 ? 1000 : dropMm;
    const initialValue = widthMm * effectiveDrop * 0.000001;
    const adjustedValue = initialValue < 1 ? 1 : initialValue;
    return adjustedValue * 10.764;
  };

  const cmToSqFt = (widthCm, dropCm) => {
    if (dropCm === 0) return 0;
    const effectiveDrop = dropCm < 100 ? 100 : dropCm;
    const initialValue = widthCm * effectiveDrop * 0.0001;
    const adjustedValue = initialValue < 1 ? 1 : initialValue;
    return adjustedValue * 10.764;
  };

  const calculateArea = (heightValue, widthValue, unit) => {
    const h = Number(heightValue) || 0;
    const w = Number(widthValue) || 0;

    if (h <= 0 || w <= 0) return 0;

    switch (unit) {
      case "inch":
        return inchesToSqFt(w, h);
      case "mm":
        return mmToSqFt(w, h);
      case "cm":
        return cmToSqFt(w, h);
      default:
        return 0;
    }
  };

  const calculateAmount = (area, qty, rate, taxRate) => {
    const a = Number(area) || 0;
    const q = Number(qty) || 0;
    const r = Number(rate) || 0;
    const t = Number(taxRate) || 0;

    const subtotal = a * q * r;
    const taxAmount = (subtotal * t) / 100;

    return {
      subtotal,
      taxAmount,
      total: Number((subtotal).toFixed(2)),
    };
  };

  // Calculate price for each product
  // const calculateProductPrice = (product) => {
  //   let area = product?.area;
  //   if (!area || area === 0) {
  //     area = calculateArea(
  //       product?.height,
  //       product?.width,
  //       product?.measurements
  //     );
  //   }
  //   const qty = quantities[product?.ROWID] || product?.quantity || 1;
  //   const rate = parseFloat(product?.sellingPrice) || parseFloat(product?.price) || 0;
  //   const taxRate = parseFloat(product?.taxRate) || parseFloat(product?.tax) || 0;

  //   return calculateAmount(area, qty, rate, taxRate);
  // };

  const calculateProductPrice = (product) => {
    console.log("Calculating price for product:", product);
    let area = product?.area;

    if (!area || area === 0) {
      area = calculateArea(
        product?.height,
        product?.width,
        product?.measurements
      );
    }

    const qty = quantities[product?.ROWID] || product?.quantity || 1;

    const rate =
      parseFloat(product?.sellingPrice) || parseFloat(product?.price) || 0;

    // Base price
    let baseSubtotal = area * qty * rate;

    // Motor price
    let motorTotal = 0;

    if (product?.motorization === "Yes" && product?.motorType && motorData.length > 0) {
      const motor = motorData.find((m) => m.ROWID === product.motorType);

      const motorPrice = parseFloat(motor?.motorPrice) || 0;

      motorTotal = motorPrice * qty;
    }

    const subtotal = baseSubtotal + motorTotal;

    return {
      subtotal: subtotal,
      taxAmount: 0,
      total: Number(subtotal.toFixed(2)),
    };
  };

  // Memoized calculations
  const productCalculations = useMemo(() => {
    const calculations = {};
    cart.forEach((product) => {
      calculations[product.ROWID] = calculateProductPrice(product);
    });
    return calculations;
  }, [cart, quantities, motorData]);

  // Calculate totals
  const subtotal = useMemo(() => {
    const total = cart.reduce((acc, product) => {
      const calc = productCalculations[product.ROWID];
      return acc + (calc?.subtotal || 0);
    }, 0);
    return total.toFixed(2);
  }, [cart, productCalculations]);

  // const shippingRate = 0.18;
  // const shippingCost = (parseFloat(subtotal) * shippingRate).toFixed(2);
  const total = (parseFloat(subtotal) + parseFloat(shippingCost)).toFixed(2);

  // Format address for display
  const formatAddress = (addr) => {
    if (!addr || Object.keys(addr).length === 0) return null;

    const parts = [];
    if (addr.name) parts.push(addr.name);
    if (addr.address) parts.push(addr.address);
    if (addr.apartment) parts.push(`Apt: ${addr.apartment}`);
    if (addr.city) parts.push(addr.city);
    if (addr.state) parts.push(addr.state);
    if (addr.postalCode) parts.push(addr.postalCode);
    if (addr.country) parts.push(addr.country);

    return parts.join(', ');
  };

  const handleConfirmOrder = () => {
    setShowWarning(false);
    createOrder();
  };

  return (
    <div className="container mx-auto">
      {loading || cartLoading ? (
        <div className="relative w-full h-[300px]">
          <Shoploader />
        </div>
      ) : cart?.length === 0 ? (
        /* Empty State */
        <div className="w-full mx-auto text-center py-16 px-4">
          <div className="max-w-md mx-auto">
            <motion.div
              animate={{
                y: [0, -20, 0],
                rotate: [0, 5, -5, 0]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                repeatType: "reverse"
              }}
            >
              <LiaOpencart className="text-8xl text-[#66944b] mx-auto" />
            </motion.div>
            <h2 className="text-3xl font-semibold text-[#661E33] mb-3">No Order Found</h2>
            <p className="text-gray-500 text-base mb-8">
              We couldn't find any order details. Please check your orders page.
            </p>
            <Link to="/shop">
              <button className="px-6 py-3 bg-[#66944b] hover:bg-[#5a8240] text-white rounded-lg font-medium transition-colors">
                Continue Shopping
              </button>
            </Link>
          </div>
        </div>
      ) : (
        <>

          {showWarning && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl shadow-lg max-w-xs lg:max-w-md  w-full p-6">

                <h2 className="text-xl font-semibold text-red-600 mb-3">
                  ⚠️ Payment Warning
                </h2>

                <p className="text-gray-700 text-sm mb-5">
                  If your payment is not successful, this order will be automatically removed from our system after 24 hours.
                </p>

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowWarning(false)}
                    className="px-4 py-2 border rounded-lg text-gray-600 hover:bg-gray-100"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleConfirmOrder}
                    className="px-4 py-2 bg-[#66944b] text-white rounded-lg hover:bg-[#5a8240]"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Order Header */}
          <div className="mb-8 flex gap-3">
                      <FaArrowLeft size="20px" className="pt-2" onClick={() => navigate(-1)} />
                   
            <h1 className="text-3xl font-playfair text-[#661e33] mb-2">Order Summary</h1>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* Order Items Table - Left Column */}
            <div className="lg:col-span-7">
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                {/* Table Header */}
                <div className="hidden md:grid grid-cols-12 gap-4 p-3 bg-gradient-to-r from-[#66944b] to-[#7fb073] rounded-t-lg text-sm font-semibold text-white uppercase tracking-wider">
                  <div className="col-span-8">Product Details</div>
                  <div className="col-span-1 text-center">Qty</div>
                  <div className="col-span-3 text-right">Total</div>
                </div>

                {/* Table Body */}
                <div className="divide-y divide-gray-200">
                  {cart.map((product) => {
                    const calc = productCalculations[product.ROWID] || {
                      subtotal: 0,
                      taxAmount: 0,
                      total: 0,
                    };
                    const area = product?.area || calculateArea(
                      product.height,
                      product.width,
                      product.measurements
                    );
                    const imageUrl = getShadeImageByShadeNo(product?.shadeNo);

                    return (
                      <div key={product?.ROWID} className="p-3 hover:bg-gray-50 transition-colors">
                        {/* Desktop View */}
                        <div className="hidden md:grid grid-cols-12 gap-4 items-center">
                          {/* Product Details */}
                          <div className="col-span-8 flex gap-4">
                            <div className="w-20 h-20 shrink-0 rounded-lg overflow-hidden bg-gray-100 border">
                              <img
                                src={imageUrl}
                                alt={product?.shadeNo}
                                className="w-full h-full object-cover"
                                // onError={(e) => {
                                //   e.target.src = "/fallback-image.jpg";
                                // }}
                              />
                            </div>
                            <div className="text-sm text-gray-500 space-y-1 mt-2">
                              <p className="flex items-start gap-2 mb-0">
                                <span className="w-32 font-medium text-gray-600 shrink-0">Dimensions</span>
                                <span>{product?.width || "0"} {product?.measurements} x {product?.height || "0"} {product?.measurements}</span>
                              </p>
                              <p className="flex items-start gap-2">
                                <span className="w-32 font-medium text-gray-600 shrink-0">Mechanism Type:</span>
                                <span>{getItemNameByProductId(product.productId)}</span>
                              </p>
                              <p className="flex items-start gap-2">
                                <span className="w-32 font-medium text-gray-600 shrink-0">Color:</span>
                                <span className="capitalize">{product?.mechanismColor || "N/A"}</span>
                              </p>
                              <p className="flex items-start gap-2">
                                <span className="w-32 font-medium text-gray-600 shrink-0">Motor:</span>
                                <span>{product?.motorization === "Yes" ? getMotorNameById(product?.motorType) : "No"}</span>
                              </p>
                              <p className="flex items-start gap-2">
                                <span className="w-32 font-medium text-gray-600 shrink-0">Side of Control:</span>
                                <span>{product?.sideOfControl || "N/A"}</span>
                              </p>
                              {product?.remarks && (
                                <p className="flex items-start gap-2">
                                  <span className="w-32 font-medium text-gray-600 shrink-0">Remark:</span>
                                  <span className="text-gray-500 italic border w-full p-1 rounded">
                                    {product?.remarks.length > 50
                                      ? `${product.remarks.substring(0, 50)}...`
                                      : product.remarks}
                                  </span>
                                </p>
                              )}
                            </div>
                          </div>

                          {/* Quantity */}
                          <div className="col-span-1 text-center">
                            <span className="font-medium">
                              {quantities[product?.ROWID] || product?.quantity || 1}
                            </span>
                          </div>

                          {/* Total */}
                          <div className="col-span-3 text-right">
                            <span className="font-bold text-[#66944b] text-lg">
                              ₹{calc.total.toFixed(2)}
                            </span>
                          </div>
                        </div>

                        {/* Mobile View */}
                        <div className="md:hidden">
                          <div className="flex gap-3 mb-3">
                            <div className="w-16 h-16 shrink-0 rounded-lg overflow-hidden bg-gray-100 border">
                              <img
                                src={imageUrl}
                                alt={product?.shadeNo}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.src = "/fallback-image.jpg";
                                }}
                              />
                            </div>
                            <div className="flex-1">
                              <h3 className="font-semibold text-gray-800">Shade {product?.shadeNo}</h3>
                              <p className="text-xs text-gray-500">
                                {product?.width || "0"} {product?.measurements} x {product?.height || "0"} {product?.measurements}
                              </p>
                            </div>
                          </div>
                          <div className="grid grid-cols-3 gap-2 text-sm">
                            <div>
                              <span className="text-gray-500 text-xs">Qty:</span>
                              <p className="font-medium">{quantities[product?.ROWID] || product?.quantity || 1}</p>
                            </div>
                            <div>
                              <span className="text-gray-500 text-xs">Unit Price:</span>
                              <p>₹{(parseFloat(product?.sellingPrice) || 0).toFixed(2)}</p>
                            </div>
                            <div className="text-right">
                              <span className="text-gray-500 text-xs">Total:</span>
                              <p className="font-bold text-[#66944b]">₹{calc.total.toFixed(2)}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Right Column - Address and Payment Summary */}
            <div className="lg:col-span-5 space-y-6">
              {/* Shipping Address Card */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-[#66944b] to-[#7fb073] p-3">
                  <h3 className="text-white font-semibold flex items-center gap-2">
                    <MapPin size={18} />
                    Shipping Address
                  </h3>
                </div>
                <div className="p-4">
                  {address && Object.keys(address).length > 0 ? (
                    <div className="space-y-3">
                      <div className="flex items-start gap-2">
                        <Home size={16} className="text-gray-400 mt-1" />
                        <div>
                          <p className="font-medium text-gray-800">{address.name}</p>
                          <p className="text-sm text-gray-600">{formatAddress(address)}</p>
                        </div>
                      </div>
                      {address.company && (
                        <div className="flex items-center gap-2">
                          <Building size={16} className="text-gray-400" />
                          <p className="text-sm text-gray-600">{address.company}</p>
                        </div>
                      )}
                      {address.phone && (
                        <div className="flex items-center gap-2">
                          <Phone size={16} className="text-gray-400" />
                          <p className="text-sm text-gray-600">{address.phone}</p>
                        </div>
                      )}
                    </div>
                  ) : (
                    <p className="text-gray-500 text-sm">No shipping address selected</p>
                  )}
                </div>
              </div>

              {/* Payment Summary Card */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-[#66944b] to-[#7fb073] p-3">
                  <h3 className="text-white font-semibold">Payment Summary</h3>
                </div>
                <div className="p-4">
                  <div className="space-y-3">
                    <div className="flex justify-between text-gray-600">
                      <span>Subtotal:</span>
                      <span className="font-medium">₹{subtotal}</span>
                    </div>
                    <div className="flex justify-between text-gray-600">
                      <span>Shipping :</span>
                      <span className="font-medium">
                        {shippingLoading ? "Calculating..." : `₹${shippingCost}`}
                      </span>
                    </div>
                    <div className="border-t pt-3 mt-3">
                      <div className="flex justify-between text-lg">
                        <span className="font-semibold">Total:</span>
                        <span className="font-bold text-[#66944b]">₹{total}</span>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-col gap-3 mt-6">
                    <button
                      className="w-full px-4 py-2 bg-[#66944b] hover:bg-[#5a8240] text-white rounded-lg transition-colors font-medium"
                      // onClick={createOrder}
                      onClick={() => setShowWarning(true)}
                      disabled={!selectedAddressId}
                    >
                      Place Order and Pay
                    </button>
                    {/* <button
                      className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      onClick={() => navigate(-1)}
                    >
                      Back to Address
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderSummary;